export const flash = () => (
  <path
    d="M12 2L3 14h9v8l9-12h-9V2z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
